import ApiService from "@/common/api.service"

export const AccreditedCourseService = {
    getAccreditedCourseService() {
        return ApiService.get("/accreditedCourseReport")
    },
    getAccreditedCourseWP(query) {
        let queryParam = `/accreditedCourseReport${query}`;
        return ApiService.get(queryParam);
    }
}